import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { formStyles } from '../ClaimCMS1500Form.styles';
import { ClaimTextField } from '../fields';

interface Box29Props {
  cleanCurrencyInput: (value: string) => string;
}

export const Box29_AmountPaid: React.FC<Box29Props> = ({ cleanCurrencyInput }) => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">29. AMOUNT PAID</Typography>
      <Controller
        name="amountPaid"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimTextField
            field={{
              ...field,
              value: field.value || '',
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                const cleaned = cleanCurrencyInput(e.target.value);
                field.onChange(cleaned);
              },
            }}
            fieldState={fieldState}
            size="small"
            fullWidth
            placeholder="0.00"
            sx={formStyles.amountField}
          />
        )}
      />
    </>
  );
};